import apiClient from './apiClient';

export interface FN01 {
  fn01_01: string; fn01_02: string; fn01_11: string; fn01_12: string;
  fn01_91: string; fn01_92: string | null; fn01_93: string;
}
export interface ListResponse { data: FN01[]; total: number; page: number; size: number; }
export interface ValidationError { field: string; message: string; }

export const complaintCauseApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/complaint-cause', { params })).data;
  },
  async get(code: string): Promise<FN01> {
    return (await apiClient.get(`/api/complaint-cause/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { fn01_02: string; fn01_11: string; fn01_12: string }): Promise<FN01> {
    return (await apiClient.post('/api/complaint-cause', data)).data;
  },
  async update(code: string, data: { fn01_11: string; fn01_12: string }): Promise<FN01> {
    return (await apiClient.put(`/api/complaint-cause/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/complaint-cause/${encodeURIComponent(code)}`);
  },
};
